// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1654509513682
      var cssReload = require("/var/www/vhosts/enconstruccion2.es/inclass.enconstruccion2.es/pcon/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  